import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import FileUpload from "app/components/file-upload";

/**
 * Proxy Stimulus controller to old style FileUpload component
 */
export default class extends Typed(Controller<HTMLDivElement>)
{
    private fileUpload: FileUpload | null = null;

    public connect(): void {
        this.fileUpload = FileUpload.getOne(this.element);
    }

    public disconnect(): void {
        this.fileUpload?.destroy();
        FileUpload.clearInstance(this.element);
        this.fileUpload = null;
    }
}
